import { backendUrl, vivekaUrl } from './../../env-config'
import { authAxios } from './../../helpers/axiosAuthInterceptor'

export const getSignupCampaigns = async () => {
  return await authAxios.get(`${backendUrl}/super-admin/tracking/campaigns`)
}

export const getSignupCampaign = async (campaign: string) => {
  return await authAxios.get(`${backendUrl}/super-admin/tracking/campaigns/${encodeURIComponent(campaign)}`)
}

// Campaigns with their own short link on the marketplace (e.g. viveka.world/cashflowy);
// any other keyword uses viveka.world/join/<campaign>.
const SHORT_LINK_CAMPAIGNS = ['cashflowy']

// Public signup link for a campaign on the marketplace
export const campaignSignupUrl = (campaign: string) => {
  const base = (vivekaUrl || '').replace(/\/+$/, '')
  return SHORT_LINK_CAMPAIGNS.includes(campaign) ? `${base}/${campaign}` : `${base}/join/${campaign}`
}

export const conversionRate = (signups: number, visits: number) =>
  visits ? `${((signups / visits) * 100).toFixed(1)}%` : '—'
